import Parametre from "@/pages/administrer/configuration/parametres/Parametre.vue";
export default [{
    path: 'parametres',
    name: "AdminConfigParametre",
    component: Parametre
}]